import styled from "styled-components";
import {GamblingSessionMessageBaseBox} from "../../boxes/gambling-session-message.box";

export const GamblingSessionWarnMessageBox = styled(GamblingSessionMessageBaseBox)`
  color: ${({theme}) => theme.colors.buttonWarning};
  text-transform: uppercase;
`